import { MEDIA_TYPE } from '../features/base/tracks/constants';
import { getLocalKinoTrack, setLocalVideoMuted } from '../features/base/tracks/functions';
import {
    isElectron,
    privacyMode,
    room,
    switchVideo,
    vb,
    Video
} from '../libs/roomnew';
export default class DeviceManager {
    constructor() {
        this.cameras = 0;
        this.microphones = 0;
        this.onSuccess = null;
        this.mutedVideoDeviceId = null;
        this.onVideoUnmuteEffect = null;
        this.cameraConstraints = constraints ? constraints :{
            video: {
                height: {
                    ideal: 720,
                    max: 720,
                    min: 360
                },
                width: {
                    ideal: 1280,
                    max: 1280,
                    min: 640
                },
                aspectRatio: 16/9
            }
        };
        this.mutedWhileSharingScreen=false;
        this.storedMicId=this.lastUsedMic();
        this.storedCameraId=this.lastUsedCamera();
        this.storedMicLabel=this.lastUsedMicLabel();
        this.storedCameraLabel=this.lastUsedCameraLabel();
        this.triedCaptureIndex=0;
    };
    addEvents() {
        var dm = this;
        $("#join-audio-only-btn").on('click', dm.joinAudioOnly.bind(dm));
        $("#join-audio-only-btn-not-found").on('click', dm.joinAudioOnly.bind(dm));
    }

    initRoom() {
        var dm = this;
        dm.cameras = 0;
        dm.microphones = 0;
        let mediadevices = dm.getDevicesByType(['videoinput', 'audioinput']);
        //let cameraDevice = dm.lastUsedCamera();
        mediadevices.then(devices => {
            devices.forEach(device => {
                if (device.kind == 'videoinput') {
                    // if(cameraDevice=="default"){
                    //     cameraDevice=device.deviceId;
                    //     dm.saveCamera(cameraDevice);
                    // }
                    dm.cameras++;
                } else if (device.kind == 'audioinput') {
                    dm.microphones++;
                }
            });
            if (dm.cameras > 0 && dm.microphones > 0) {
                console.log("found cameras " + dm.cameras);
                dm.getMediaDevices(['audio', 'video']);
            } else if (dm.cameras == 0 && dm.microphones > 0) {
                console.log("no camera found");
                dm.canNotAccessCamera();
            } else if (dm.cameras > 0 && dm.microphones == 0) {
                //no microphone found
                dm.noMicFound();
            } else {
                dm.noMediaDevicesCaptured();
                //getUserDevices(['audio']);
                clearTimeout(permisionTimeout);
            }
        }).catch((error) => {
            //throw error;
            console.log('Can not fetch camera devices',error);
            dm.getMediaDevices(['audio', 'video']);
        });
    };
    getAvailableDevicesTypes(){
        var dm = this;
        dm.cameras = 0;
        dm.microphones = 0;
        return new Promise((resolve,reject)=>{
            let mediadevices = dm.getDevicesByType(['videoinput', 'audioinput']);
            //let cameraDevice = dm.lastUsedCamera();
            mediadevices.then(devices => {
                devices.forEach(device => {
                    if (device.kind == 'videoinput') {
                        // if(cameraDevice=="default"){
                        //     cameraDevice=device.deviceId;
                        //     dm.saveCamera(cameraDevice);
                        // }
                        dm.cameras++;
                    } else if (device.kind == 'audioinput') {
                        dm.microphones++;
                    }
                });
                if (dm.cameras > 0 && dm.microphones > 0) {
                    console.log("found cameras " + dm.cameras);
                    resolve(['audio', 'video']);
                } else if (dm.cameras == 0 && dm.microphones > 0) {
                    resolve(['audio']);
                } else if (dm.cameras > 0 && dm.microphones == 0) {
                    resolve(['video']);
                } else {
                    resolve(['audio', 'video']);
                }
            }).catch((error) => {
                //throw error;
                console.log('Can not fetch camera devices',error);
                resolve(['audio', 'video']);
            });
        });

    };
    getMediaDevices(devices) {
        var dm = this;
        console.log("Requesting devices:", devices);
        let cameraDevice = dm.lastUsedCamera();
        let micDevice = dm.lastUsedMic();
        console.log(`Requesting devices: camera ${cameraDevice} , mic `);
        let initConstraints = constraints;
        if (cameraDevice && cameraDevice!="default") {
            initConstraints.video['deviceId'] = {
                exact: cameraDevice
            };
        }
        if (micDevice) {
            if (initConstraints['audio'] !== undefined) {
                initConstraints['audio']['optional'] = [{
                        sourceId: micDevice
                    },
                    {
                        echoCancellationType: "system"
                    }
                ];
            } else {
                initConstraints['audio'] = {
                    optional: [{
                            sourceId: micDevice
                        },
                        {
                            echoCancellationType: "system"
                        }
                    ]
                };
            }
        }
        //console.warn("Check if P2P is active",room.isP2PActive());
        console.log("capturing camera device with constraints",initConstraints)
        KinoJS.createLocalTracks({
                devices: devices,
                resolution: 720,
                constraints: initConstraints,
                cameraDeviceId: cameraDevice && cameraDevice!=="default" ? {
                    exact: cameraDevice
                } : false,
                micDeviceId: micDevice ? {
                    exact: micDevice
                }: 'communications'
            })
            .then(dm.onSuccess ? dm.onSuccess.bind(this) : (tracks) => {
                console.log("Successfully got tracks", tracks);
            }) //video and audio allow
            .catch((error) => {
                dm.errorHandler(error);
            });
    };

    joinAudioOnly() {
        var dm = this;
        dm.clearErrorMessages();
        dm.getMediaDevices(['audio']);
    };

    /**
     *
     * @param selected
     */
    changeAudioOutput(selected) {
        // eslint-disable-line no-unused-vars
        try {
            KinoJS.mediaDevices.setAudioOutputDevice(selected);
            this.saveSpeaker(selected);
        } catch (err) {
            console.error('Change output error',err);
            this.saveSpeaker('communications');
        }

    };

    areDevicesChanged(mic={},camera=false){
        let changed=false;
        try {
            if(camera && camera.id!=this.storedCameraId || (this.storedCameraLabel && camera.label!=this.storedCameraLabel)){
                changed=true;
            }
            if(mic.id!=this.storedMicId || (this.storedMicLabel && mic.label != this.storedMicLabel)){
                changed=true;
            }
        } catch (error) {

        }
        return changed;
    };

    muteVideo() {
        var dm = this;
        return new Promise(function (resolve, reject) {
            try {
                if (!room) {
                    reject(new Error("Room is not initialized"));
                }
                let videoTrack = getLocalKinoTrack(MEDIA_TYPE.VIDEO);
                if (videoTrack && videoTrack.stream) {
                    dm.mutedVideoDeviceId = videoTrack.getDeviceId();
                    videoTrack.stream.stop();
                    if(videoTrack._originalStream){
                        videoTrack._originalStream.stop();

                        videoTrack._originalStream.getTracks().map(t=>t.stop());
                        console.log(`Original stream found with tracks`,videoTrack._originalStream.getTracks());
                        videoTrack._originalStream=undefined;
                    }
                    if (vb.streamEffect) {
                        vb.streamEffect.stopEffect();
                        vb.streamEffect = undefined;
                    }
                    if(privacyMode.enabled){
                        console.log("privacy mode is enabled stopping...");
                        privacyMode.streamEffect.stopEffect();
                        privacyMode.streamEffect = undefined;
                        if(privacyMode.originalStream){
                            console.log(`Original stream found with tracks`,privacyMode.originalStream.getTracks());
                            privacyMode.originalStream.stop();
                            privacyMode.originalStream=undefined;
                        }
                    }
                    console.trace("muted video track deviceID", dm.mutedVideoDeviceId);
                    Video.cameraMuted(room.myUserId(),true);
                    setLocalVideoMuted(true)
                    room.setLocalParticipantProperty('video_muted', true);
                    resolve(true);
                } else {
                    reject(new Error(`No track found to mute`));
                }

            } catch (error) {
                reject(error);
            }
        });
    };
    unMuteVideo() {
        var dm = this;
        return new Promise(function (resolve, reject) {
            try {
                if (!room) {
                    reject(new Error("Room is not initialized"));
                }
                if (dm.mutedVideoDeviceId) {
                    switchVideo(dm.mutedVideoDeviceId).then(()=>{
                        dm.mutedVideoDeviceId = null;
                        Video.cameraMuted(room.myUserId(),false);
                        room.setLocalParticipantProperty('video_muted', false);
                        resolve(true);
                    }).catch(err=>{
                        reject(err);
                    });
                } else {
                    console.warn(`Did not found muted device id,falling to last used camera`, dm.mutedVideoDeviceId);
                    let lastUsedCameraid = dm.lastUsedCamera();
                    if (lastUsedCameraid) {
                        switchVideo(lastUsedCameraid).then(()=>{
                            dm.mutedVideoDeviceId = null;
                            room.setLocalParticipantProperty('video_muted', false);
                            resolve(true);
                        }).catch(err=>{
                            reject(err);
                        });
                    }else{
                        reject(new Error("No device Id found to unmute"));
                    }
                }
            } catch (error) {
                reject(error);
            }
        });
    };
/**
 *
 * @param {*} id Camera deviceId
 * @returns Promise
 */
    captureCamera(id = undefined,options={resolution:720}) {
        let constraints = this.cameraConstraints;
        if(constraints.video && options.frameRate){
            constraints.video['frameRate']={
                ideal:options.frameRate,
                min: options.frameRate < 30 ? 5 : 15,
                max: options.frameRate >=30 ? 60 : options.frameRate
            };
        }
        return new Promise(function (resolve, reject) {
            KinoJS.createLocalTracks({
                    devices: ['video'],
                    resolution: options.resolution ? options.resolution: 720,
                    constraints: constraints,
                    cameraDeviceId: id ? {
                        exact: id
                    } : false
                }, true)
                .then(tracks => {
                    tracks.forEach(function (videoTrack) {
                        if (videoTrack.deviceId == id) {
                            resolve(videoTrack);
                            return;
                        }
                    });
                }).catch(error => reject(error));

        });

    };

    lastUsedCamera() {
        try {
            let camera_id = localStorage.getItem('camera_id');
            if (camera_id) {
                return camera_id;
            } else {
                return false;
            }
        } catch (e) {
            console.log(e.message);
            return false;
        }
    };

    lastUsedMic() {
        try {
            let microphone_id = localStorage.getItem('microphone_id');
            if (microphone_id) {
                return microphone_id;
            } else {
                return false;
            }
        } catch (e) {
            console.log(e.message);
            return false;
        }
    };

    lastUsedMicLabel() {
        try {
            let microphone_label = localStorage.getItem('microphone_label');
            if (microphone_label) {
                return microphone_label;
            } else {
                return false;
            }
        } catch (e) {
            console.log(e.message);
            return false;
        }
    };
    lastUsedCameraLabel() {
        try {
            let camera_label = localStorage.getItem('camera_label');
            if (camera_label) {
                return camera_label;
            } else {
                return false;
            }
        } catch (e) {
            console.log(e.message);
            return false;
        }
    };

    lastUsedSpeaker() {
        try {
            let speaker_id = localStorage.getItem('speaker_id');
            if (speaker_id) {
                return speaker_id;
            } else {
                return 'default';
            }
        } catch (e) {
            console.log(e.message);
            return 'default';
        }
    };
    saveSpeaker(id) {
        try {
            localStorage.setItem('speaker_id', id);
        } catch (e) {
            console.log(e.message);
        }
    };
    saveMic(id,label=false) {
        try {
            // console.log(`Storing mic ${id} label ${label}`)
            localStorage.setItem('microphone_id', id);
            if(label !== false){
                localStorage.setItem('microphone_label', label);
            }
        } catch (e) {
            console.log(e.message);
        }
    }

    saveCamera(id,label=false) {
        try {
            // console.log(`Storing camera ${id} label ${label}`)
            localStorage.setItem('camera_id', id);
            if(label !== false){
                localStorage.setItem('camera_label', label);
            }
        } catch (e) {
            console.log(e.message);
        }
    };

    errorHandler(error) {
        var dm = this;
        console.error("Failed to get media device", error);
        switch (error.name) {
            case "gum.general":
                dm.handleGeneralError(error);
                break;
            case "gum.unsupported_resolution":
                dm.resetCameraDevice();
                break;
            case "gum.permission_denied":
                dm.noPermissionError();
                break;
            case "gum.not_found":
                dm.noMediaDevicesCaptured();
                break;
            case "OverconstrainedError":
                dm.resetCameraDevice();
                break;
            default:
                dm.canNotAccessCamera();
                return;
                break;
        }
    };
    handleGeneralError(error) {
        var dm = this;
        if (error.message == "Could not start video source") {
            dm.resetCameraDevice();
        } else {
            dm.noMediaDevicesCaptured();
        }
    };

    resetCameraDevice(callback=false) {
        var dm = this;
        console.log("Reseting camera devices");
        let lastCamera = dm.lastUsedCamera();
        console.log("Last camera used " + lastCamera + " camerdaveices " + dm.cameras.length);
        if (dm.cameras > 0 && lastCamera != 'default') {
            console.log("Setting default camera");
            dm.saveCamera('default','');
            if(callback){
                callback(true);
            }else{
                window.location.reload();
            }
            return;
        } else {
            console.log("Can not access camera error");
            if(callback){
                callback(false);
            }else{
                dm.canNotAccessCamera();
            }
        }
    };

    async getDevicesByType(type) {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.filter(device => type.includes(device.kind))
    };

    getNextAvailableCamera() {
        return new Promise(async (resolve, reject) => {
            const cameras = await this.getDevicesByType(['videoinput']);
            let found=null;
            let lastCameraId = this.lastUsedCamera();
            if((this.triedCaptureIndex + 1) === cameras.length){
                return reject();
            }
            console.log("Try next cameras,",cameras," last camera id",lastCameraId)
            const startIndex = Math.min(this.triedCaptureIndex + 1,cameras.length-1)
            if(cameras.length > 1){
                for (let index = startIndex; index < cameras.length; index++) {
                    const cam = cameras[index];
                    if(cam.deviceId == lastCameraId){
                        continue;
                    }
                    found = cam;
                    this.triedCaptureIndex=index;
                    break

                }
            }
            return found ? resolve(found) : reject();
        })
    }

    generateCameraSelect(select) {
        var dm = this;
        $('#pleaseWaitMessage').css("display", "none");
        let videoDevices = dm.getDevicesByType(['videoinput']);
        videoDevices.then(cameras => {
            dm.cameras = cameras.length;
            select.off();
            select.html('<option value="">Choose an available camera</option>');
            select.append('<option value="default">Default Camera</option>');
            cameras.forEach(function (device) {
                if (device.label == "") {
                    device.label = device.deviceId;
                }
                let option = $('<option/>', {
                    value: device.deviceId,
                    html: device.label
                });
                select.append(option);
            });
            select.on('change', function (e) {
                if ($(this).val() != "") {
                    console.log("saving camera", $(this).val());
                    dm.saveCamera($(this).val(),'');
                    $('#pleaseWaitMessage').css("display", "flex");
                    window.location.reload();
                }
            });
        }).catch((error) => {
            select.html('');
        });
    };


    //errors
    canNotAccessCamera() {
        var dm = this;
        // dm.generateCameraSelect($('#error-video-devices'));
        // document.getElementById("continueWithoutCamera").style.display = "flex";
    };
    noPermissionError() {
        // document.getElementById("permissionOverlaydenied").style.display = "flex";
    };
    noMediaDevicesCaptured() {
        // document.getElementById("noCameraOrMicConnected").style.display = "flex";
    };
    noCameraFound() {
        // document.getElementById("noCameraConnected").style.display = "flex";
    };
    noMicFound() {
        // document.getElementById("noMicrophoneConnected").style.display = "flex";
    };
    requestPermissionMessage() {
        // document.getElementById("permissionOverlay").style.display = "flex";
    };
    clearErrorMessages() {
        // document.getElementById("permissionOverlaydenied").style.display = "none";
        // document.getElementById("permissionOverlay").style.display = "none";
        // document.getElementById("continueWithoutCamera").style.display = "none";
        // document.getElementById("noCameraOrMicConnected").style.display = "none";
        // document.getElementById("noCameraConnected").style.display = "none";
        // document.getElementById("noMicrophoneConnected").style.display = "none";
        // $('#pleaseWaitMessage').css("display", "none");
    };

    getCameraTrack(deviceID=false){
        var dm=this;
        let cameraDevice = deviceID ? deviceID : dm.lastUsedCamera();
        console.log(`Requesting devices: camera ${cameraDevice}`);
        let initConstraints = constraints;
        if (cameraDevice && cameraDevice!="default") {
            initConstraints.video['deviceId'] = {
                exact: cameraDevice
            };
        }

        return KinoJS.createLocalTracks({
            devices: ['video'],
            resolution: 720,
            constraints: initConstraints,
            cameraDeviceId: cameraDevice && cameraDevice!=="default" ? {
                exact: cameraDevice
            } : false
        });
    };

    getAudioTrack(deviceID=false) {
        var dm = this;
        let micDevice = deviceID ? deviceID : dm.lastUsedMic();
        console.log(`Requesting devices: mic ${micDevice} , mic `);
        let initConstraints = constraints;

        if (micDevice) {
            if (initConstraints['audio'] !== undefined) {
                initConstraints['audio']['optional'] = [{
                        sourceId: micDevice
                    },
                    {
                        echoCancellationType: "system"
                    }
                ];
            } else {
                initConstraints['audio'] = {
                    optional: [{
                            sourceId: micDevice
                        },
                        {
                            echoCancellationType: "system"
                        }
                    ]
                };
            }
        }
        //console.warn("Check if P2P is active",room.isP2PActive());
         console.log("capturing microphone device with constraints",initConstraints)
         return KinoJS.createLocalTracks({
                devices: ['audio'],
                resolution: 720,
                constraints: initConstraints,
                micDeviceId: micDevice ? {
                    exact: micDevice
                }: 'communications'
            });
    };

    async getAudioVideoTrack() {
        var dm = this;
        let micDevice = dm.lastUsedMic();
        let cameraDevice = dm.lastUsedCamera();
        let deviceTypes=await dm.getAvailableDevicesTypes();
        console.log(`Requesting devices: mic ${micDevice} , camera ${cameraDevice},media device`,deviceTypes);
        let initConstraints = constraints;
        console.log(`Requesting devices: camera ${cameraDevice}`);
        if (cameraDevice && cameraDevice!="default" && deviceTypes.includes('video')) {
            initConstraints.video['deviceId'] = {
                exact: cameraDevice
            };
        }else{
            delete initConstraints.video['deviceId'];
        }
        if (micDevice && deviceTypes.includes('audio')) {
            if (initConstraints['audio'] !== undefined) {
                initConstraints['audio']['optional'] = [{
                        sourceId: micDevice
                    },
                    {
                        echoCancellationType: "system"
                    }
                ];
            } else {
                initConstraints['audio'] = {
                    optional: [{
                            sourceId: micDevice
                        },
                        {
                            echoCancellationType: "system"
                        }
                    ]
                };
            }
        }
        //console.warn("Check if P2P is active",room.isP2PActive());
         console.log("capturing audioVideo devices with constraints",initConstraints)
         return KinoJS.createLocalTracks({
                devices: deviceTypes,
                resolution: 720,
                constraints: initConstraints,
                micDeviceId: micDevice ? {
                    exact: micDevice
                }: 'communications',
                cameraDeviceId: cameraDevice && cameraDevice!=="default" ? {
                    exact: cameraDevice
                } : false
            });
    };

    clearMicAudioContext(){
        if(this.audioContext){
            console.log("Clearing mic audio context");
            this.audioContext.close();
            this.audioContext=null;
        }
    }

    getSpeakers(){
        console.log("getting speakers");
        return new Promise((resolve)=>{
            KinoJS.mediaDevices.enumerateDevices((devices) => {
                console.log("Got speaker devices",devices);
                let countdevices=devices.filter(d=>d.kind == "audiooutput" && d.deviceId);
                resolve(countdevices);
            });
        });
    };

    getMicrophones(){
        console.log("getting microphones");
        return new Promise((resolve)=>{
            KinoJS.mediaDevices.enumerateDevices((devices) => {
                console.log("Got microphone devices",devices);
                let countdevices=devices.filter(d=>d.kind == "audioinput");
                resolve(countdevices);
            });
        });
    };

    getCameras(){
        console.log("getting cameras");
        return new Promise((resolve)=>{
            KinoJS.mediaDevices.enumerateDevices((devices) => {
                console.log("Got camera devices",devices);
                let countdevices=devices.filter(d=>d.kind == "videoinput");
                resolve(countdevices);
            });
        });
    };

};
